import { isAppleTouchDevice } from '@/lib/platform';
/**
 * Inline PDF previews (an <iframe> on a blob: URL) rely on the browser's own
 * PDF viewer. iOS and iPadOS Safari do not give an iframe that viewer: they
 * paint the first page as a static image with no paging, so a reader checking
 * a multi-page report before signing would only ever see page 1. On those
 * devices the preview surfaces also offer "Open PDF", which hands the same
 * blob to Safari's full-page viewer.
 */
export function inlinePdfShowsFirstPageOnly() {
    return isAppleTouchDevice();
}
/**
 * Opens one of our own PDF blobs in a new tab. Must run synchronously inside
 * the click handler: iOS Safari only allows window.open from a user gesture.
 * `noopener` keeps the new tab off window.opener; a same-origin blob: URL
 * still resolves there (the blob store is shared across the origin's tabs).
 */
export function openPdfInNewTab(url) {
    window.open(url, '_blank', 'noopener');
}
